import { createSelector } from 'reselect';

const substate = (state) => state.policy;

export const selectPolicyTestOverride = () =>
    createSelector(substate, (contextState) => contextState.policyTestOverride);
